import { CasProvider } from './providers/CasProvider';
import { DummyProvider } from './providers/DummyProvider';
import { EntraProvider } from './providers/EntraProvider';

export class AuthProviderFactory {
    constructor() { }

    build(authConfig) {
        if(authConfig) {
            const useEntra = authConfig.featureFlags?.use_azure_app_registration === true;

            if (useEntra && authConfig.entra) {
                return new EntraProvider(authConfig.entra);
            }

            return new CasProvider(authConfig.cas);
        }
        else {
            return new DummyProvider();
        }
    }
}

const authFactory = new AuthProviderFactory();
export default authFactory;